import { BookOpen } from "lucide-react";

interface GuideShortcutsProps {
  onOpenGuide: (type: "week" | "weekend") => void;
}

/**
 * Phone-only links to the weekly and weekend guides. They sit inside the event
 * list (after the first few cards) instead of the discovery bar, so the first
 * phone screen shows events rather than extra buttons.
 */
export function GuideShortcuts({ onOpenGuide }: GuideShortcutsProps) {
  const buttonClassName =
    "inline-flex min-h-[44px] min-w-0 flex-1 items-center justify-center gap-1.5 rounded-full border border-[#cfe1d5] bg-white px-3 text-sm font-semibold text-[#17664f] transition-all hover:border-[#8fbb9f] hover:bg-[#f0f7f2] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1D9E75] focus-visible:ring-offset-2";

  return (
    <aside
      aria-labelledby="guide-shortcuts-heading"
      className="col-span-full rounded-[18px] border border-[#d9e6dc] bg-[#f5f8f3] px-3 py-3 md:hidden"
      data-testid="mobile-guide-shortcuts"
    >
      <h2 id="guide-shortcuts-heading" className="text-sm font-semibold text-[#292721]">
        Not sure what to pick?
      </h2>
      <p className="mt-0.5 text-xs text-[#746d62]">Our guides highlight the best local events.</p>
      <div className="mt-2.5 flex gap-2">
        <button
          type="button"
          onClick={() => onOpenGuide("weekend")}
          aria-haspopup="dialog"
          className={buttonClassName}
          data-testid="mobile-weekend-guide"
        >
          <BookOpen className="h-4 w-4 shrink-0" aria-hidden="true" />
          Weekend guide
        </button>
        <button
          type="button"
          onClick={() => onOpenGuide("week")}
          aria-haspopup="dialog"
          className={buttonClassName}
          data-testid="mobile-week-guide"
        >
          <BookOpen className="h-4 w-4 shrink-0" aria-hidden="true" />
          This week
        </button>
      </div>
    </aside>
  );
}
